export const layerStyles = {
  gradient: {
    primary: {
      bgGradient:
        "linear-gradient(285deg, rgba(79, 70, 229, 0.76) 2%, primary 92%)",
    },
  },
};
